import * as React from 'react';
import * as Glob from '../Globale';
import * as DatiRCP from '../DatiRCP';
import * as Dati from '../Dati';
import { ChiamaAPI, BottoneAPI, Trad, BaseComponent, Tipo } from '../components/';
import { Contesto } from '../components/';
import ReactJson from 'react-json-view';
import { NavLink } from 'react-router-dom';
import { CampoNumero } from '../components/';

interface IBinderProdottoGaranzia {
    Dato: DatiRCP.CRisAPIBinderProdottiGaranzie;
    Aggiornare: number;
}

export class BinderProdottoGaranzia extends BaseComponent<Glob.IRouteGlobaleProps, IBinderProdottoGaranzia> {
    private infoContesto: Dati.InfoContesto[] = [];
    private _ProprietaSelezione: Dati.TDictTipo = {};

    public constructor(props: any) {
        super(props);
        let dato: DatiRCP.CRisAPIBinderProdottiGaranzie = new DatiRCP.CRisAPIBinderProdottiGaranzie();
        this.state = {
            Dato: dato,
            Aggiornare: 1
        };
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);

        this._ProprietaSelezione = {};
        this._ProprietaSelezione["S"] = new Dati.CTipo("S", "Selezionabile");
        this._ProprietaSelezione["P"] = new Dati.CTipo("P", "Preselezionato");
        this._ProprietaSelezione["O"] = new Dati.CTipo("O", "Obbligatorio");
    }

    private OnRis(dati: DatiRCP.CRisAPIBinderProdottiGaranzie, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Dato: dati });
        }
        return true;
    }

    private OnClickSalva(dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("STATI ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            this.setState({ Aggiornare: this.state.Aggiornare + 1 });
            Glob.InfoModaleSuccess(Trad.Trad("GARANZIE"), (Trad.Trad("GaranzieAggiornateCorrettamente")));
        }
    }

    private OnInvioSalva(): any {
        return this.state.Dato.Dati;
    }

    private OnErroreBottoneAPI(errore: Error) {
        Glob.InfoModaleError(Trad.Trad("GARANZIEERRORE"), Trad.Trad(errore.message));
    }

    public render() {

        let BinderProdottiGaranzie: any[] = [];
        this.infoContesto = [];
        this.infoContesto.push(new Dati.InfoContesto(Trad.Trad("Binder"), "/api/binder/Contesto?ID_Binder=" + (this.props.match.params as any).ID_Binder, "/binder/" + (this.props.match.params as any).ID_Binder));
        for (let i: number = 0; i < this.state.Dato.Dati.length; i++) {
            BinderProdottiGaranzie.push(<div className="kt-form login-form__group form-group row" key={i}>
                <div className="col-lg-4">
                    <label className="col-1 col-form-label">{Trad.Trad("TipoProdotto")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <Tipo Campo={"Dato.Dati[" + i + "].ID_TipoProdotto"} ID_Chiave={this.state.Dato.Dati[i].ID_TipoProdotto || 0} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi != undefined ? this.state.Dato.Tipi["TipiProdotti"] : undefined} />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label className="col-1 col-form-label">{Trad.Trad("Garanzia")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <Tipo Campo={"Dato.Dati[" + i + "].ID_TipoGaranzia"} ID_ChiaveString={this.state.Dato.Dati[i].ID_TipoGaranzia || ''} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi != undefined ? this.state.Dato.Tipi["TipiGaranzie_" + (this.state.Dato.Dati[i].ID_TipoProdotto || 0)] : undefined} />
                    </div>
                </div>
                <div className="col-lg-4">
                    <label className="col-1 col-form-label">{Trad.Trad("NomeClasseGaranzia")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <Tipo Campo={"Dato.Dati[" + i + "].NomeClasseGaranzia"} ID_ChiaveString={this.state.Dato.Dati[i].NomeClasseGaranzia || ''} OnAggiorna={this.OnChange} Dati={this.state.Dato.Tipi != undefined ? this.state.Dato.Tipi["NomeClasseGaranzia"] : undefined} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <label className="col-1 col-form-label">{Trad.Trad("Descrizione")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" className="form-control kt-input" value={this.state.Dato.Dati[i].Descrizione || ""} name={"Dato.Dati[" + i + "].Descrizione"} onChange={(e) => { this.OnChange(e) }} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <label className="col-1 col-form-label">{Trad.Trad("Ordine")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero Name={"Dato.Dati[" + i + "].Ordine"} Id={"Dato.Dati[" + i + "].Ordine"} Valore={this.state.Dato.Dati[i].Ordine} OnChange={(e) => this.OnChange(e)} CSS="form-control kt-input" Icona="" Precisione={0} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <label className="col-1 col-form-label">{Trad.Trad("ProprietaSelezione")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <Tipo Campo={"Dato.Dati[" + i + "].ProprietaSelezione"} ID_ChiaveString={this.state.Dato.Dati[i].ProprietaSelezione || ""} OnAggiorna={this.OnChange} Dati={this._ProprietaSelezione} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <label className="col-1 col-form-label">{Trad.Trad("Icona")}</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" name={"Dato.Dati[" + i + "].Icona"} id={"Dato.Dati[" + i + "].Icona"} value={this.state.Dato.Dati[i].Icona} onChange={(e) => this.OnChange(e)} className="form-control kt-input" />
                        <span className="kt-input-icon__icon kt-input-icon__icon--right"><span><i className={this.state.Dato.Dati[i].Icona}></i></span></span>
                    </div>
                </div>
            </div>);
        }

        return <div>
            <Contesto Id="InfoContesto" Info={this.infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-money-bill-wave"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                <div className="col-lg-12 TextLeft">
                                    <h5>
                                        <NavLink onClick={() => { this.state.Dato.Dati.unshift(new DatiRCP.CBinderProdottiGaranzie((this.props.match.params as any).ID_Binder, (this.props.match.params as any).ID_Binder)) }} to="#" className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg arrow" title={Trad.Trad("Nuovo")}>
                                            <i className="fa fa-plus"></i>
                                        </NavLink>
                                    </h5>
                                </div>
                                {Trad.Trad("GARANZIE")}
                            </h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className={"col-lg-12 kt--align-right"}>
                                <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/BinderProdottoGaranzia" Metodo="POST" OnClick={(s, d) => this.OnClickSalva(d)} OnInvio={(s) => this.OnInvioSalva()} OnErrore={(s, e) => this.OnErroreBottoneAPI(e)} Visibile={this._Scrittura} />
                            </div>
                        </div>
                        {BinderProdottiGaranzie}
                    </div>

                </form>
            </div>
            <ChiamaAPI Aggiornare={this.state.Aggiornare} URL={"/api/BinderProdottoGaranzia?id_Binder=" + (this.props.match.params as any).ID_Binder} Metodo="GET" OnRis={(s, d, dn) => this.OnRis(d, dn)} OnErrore={this.OnErrore} />
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/form/BinderProdottoGaranzia.tsx